import React from 'react';
import {
  DataGridLayout,
  DateTimeRangeFilter,
  DESC,
  Filters,
  FiltersLayout,
  List,
  ListHeader,
  ListPageLayout,
  SearchInput,
} from 'framework/list';
import { FullDateField, PhoneSearchField, SearchResultField } from 'framework/ui/field';
import AccountTypeField from 'domain/sales/account/shared/field/AccountTypeField';
import EditAccountButton from 'domain/sales/account/shared/Button/EditAccountButton';
import CreateAccountButton from 'domain/sales/account/list/buttons/CreateAccountButton';
import AccountSearchLinkField from 'domain/sales/account/list/field/AccountSearchLinkField';
import OwnerFilter from 'domain/sales/shared/filter/OwnerFilter';
import AccountTypeFilter from 'domain/sales/account/list/filter/AccountTypeFilter';
import { useAuthorization } from 'framework/authorization';
import useAccountManagementService from '../useAccountManagementService';
import { READ_FULL_ACCOUNTS_LIST, UPDATE_ACCOUNT_FROM_LIST_PAGE } from '../model';

const AccountsListPage = () => {
  const { search, getFilterValidationSchema } = useAccountManagementService();
  const { isGranted } = useAuthorization();

  const filters = (
    <Filters getValidationSchema={getFilterValidationSchema}>
      <FiltersLayout>
        <AccountTypeFilter label="Account type" source="accountType" />
        <OwnerFilter label="Account owner" source="owner.alias" isVisible={isGranted(READ_FULL_ACCOUNTS_LIST)} />
        <DateTimeRangeFilter label="Created date" source="createdAt" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <List getDataMethod={search} defaultSortOrder={DESC} defaultSortField="updatedAt">
      <ListPageLayout
        header={<ListHeader label="Accounts" icon="fa-id-card" />}
        filter={filters}
        actions={[<CreateAccountButton />]}
        search={<SearchInput label="account name or ID" />}
      >
        <DataGridLayout
          buttons={[<EditAccountButton source="accountId" outline permissionToCheck={UPDATE_ACCOUNT_FROM_LIST_PAGE} />]}
        >
          <AccountSearchLinkField idSource="accountId" label="Account ID" source="id" isSortable width={150} />
          <SearchResultField label="Account name" source="accountName" isSortable />
          {/* TODO: remove after month */}
          <SearchResultField label="Original name" source="originalName" isSortable />
          <PhoneSearchField source="phoneNumber" label="Phone" isSortable />
          <AccountTypeField source="accountType" label="Account type" isSortable />
          <FullDateField source="createdAt" label="Created date" isSortable />
          <FullDateField source="updatedAt" label="Last modified date" isSortable />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default AccountsListPage;
